<app-modal-header (closeModal)="close()" />
<app-modal-body>
  <div class="row pb-4">
    <div class="col-md-11 col-12 mx-auto">
      <h1 class="fs-5">{{ 'GET_THE_APP' | translate }}</h1>
      <p class="mb-0">
        {{ 'GET_THE_APP_DESC' | translate }}
      </p>
      <div class="row mt-3">
        <div class="col-6">
          <div class="card text-center">
            <div class="card-body">
              <button type="btn" class="btn btn-sm border-1 border-dark" (click)="openLinkIOS()">
                <i class="ri-external-link-line fs-6 pe-1"></i>{{ 'FOR_IOS' | translate }}
              </button>
              <div>
                <canvas #qrIOSApps></canvas>
              </div>
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="card text-center">
            <div class="card-body">
              <button type="btn" class="btn btn-sm border-1 border-dark" (click)="openLinkAndroid()">
                <i class="ri-external-link-line fs-6 pe-1"></i>{{ 'FOR_ANDROID' | translate }}
              </button>
              <div>
                <canvas #qrAndroidApps></canvas>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</app-modal-body>
